import React from "react";

const LoanTermsAndConditions = () => {
  return (
    <div className="w-full p-6">
      <h1 className="text-2xl font-bold mb-4">HELACRED</h1>
      <h2 className="text-xl font-semibold mb-6">
        LOAN TERMS AND CONDITIONS AGREEMENT
      </h2>

      <div className="space-y-4 text-gray-700 leading-relaxed">
        <p>
          This Loan Agreement ("Agreement") is made on <strong>[Date]</strong>,
          by and between:
        </p>

        <p>
          <strong>HELACRED</strong>, a credit-only company duly
          registered in the Republic of Kenya, with its registered office at{" "}
          <strong>[JM PLAZA KAHAWA WEST]</strong>
          (hereinafter referred to as the "Lender");
        </p>

        <p>
          AND <strong>[Borrower&apos;s Full Name]</strong>, a resident of
          <strong> [Borrower&apos;s Full Address]</strong>, holder of National
          ID Number
          <strong> [Borrower&apos;s ID Number]</strong> (hereinafter referred to
          as the "Borrower").
        </p>

        <ol className="list-decimal list-inside space-y-3">
          <li>
            <strong>Loan and Disbursement:</strong>
            The Lender agrees to grant a loan to the Borrower in the principal
            amount of
            <strong> [Loan Amount in Words]</strong> (KES{" "}
            <strong>[Loan Amount in Figures]</strong>). The loan will be
            disbursed to the Borrower through
            <strong>
              {" "}
              [Method of Disbursement, e.g., M-PESA, Bank Transfer]
            </strong>
            .
          </li>

          <li>
            <strong>Interest and Fees:</strong>
            The loan shall be subject to an interest rate of{" "}
            <strong>[Interest Rate]</strong>
            20% per month. In addition, the Borrower agrees to pay a processing
            fee at the time of loan application as stipulated in the debt
            acknowledgment.
          </li>

          <li>
            <strong>Repayment Obligation:</strong>
            The Borrower agrees and undertakes to repay the total debt,
            including the principal, interest, and all applicable fees, in the
            sum of KES <strong>[Total Repayable Amount]</strong>
            on or before <strong>[Repayment Due Date(s)]</strong>.
          </li>

          <li>
            <strong>Default:</strong>
            In case of default:
            <ul className="list-disc list-inside ml-5 space-y-1">
              <li>
                Interest at 20% per month on the unpaid principal will continue
                to accrue.
              </li>
              <li>A debt recovery fee of Ksh 10,000 will apply.</li>
              <li>
                A penalty of 3% per day on the overdue amount will apply until
                settlement.
              </li>
            </ul>
          </li>

          <li>
            <strong>Irrevocable Assignment and Recovery:</strong>
            The Borrower irrevocably assigns all rights, title, and interest in
            the assets contained in the Asset Schedule and/or any other asset
            attachable in their premises. The Lender may enter upon their
            premises and dispose of pledged assets by public auction or any
            other method upon default.
          </li>

          <li>
            <strong>Covenants of the Borrower:</strong>
            The Borrower warrants all information provided is true. The Lender
            may contact the Borrower&apos;s employer and listed guarantors for
            verification.
          </li>

          <li>
            <strong>Data Protection and Privacy:</strong>
            The Borrower consents to HELACRED collecting and using
            personal information for loan management. Data may be shared with
            third parties (e.g., credit bureaus, guarantors).
          </li>

          <li>
            <strong>Governing Law and Dispute Resolution:</strong>
            This Agreement is governed by the laws of Kenya. Disputes will be
            resolved through negotiation, and if unsuccessful, by arbitration in
            Nairobi.
          </li>

          <li>
            <strong>Entire Agreement:</strong>
            This Agreement constitutes the full understanding between the
            Borrower and the Lender and supersedes prior agreements.
          </li>
        </ol>

        <div className="mt-6 space-y-2">
          <p>
            IN WITNESS WHEREOF, the Borrower has executed this Agreement on the
            date first above written.
          </p>
          <p>Borrower&apos;s Signature: _________________________</p>
          <p>Printed Name: _________________________</p>
          <p>Date: _________________________</p>
        </div>
      </div>
    </div>
  );
};

export default LoanTermsAndConditions;
